import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { UserDto } from "app/modules/dashboard/modules/management/user/model/user.dto";
import * as wjCore from "wijmo/wijmo";
import * as wjGrid from "wijmo/wijmo.grid";
import { ApiService } from "app/modules/shared/services/base/api.service";
import { ToastService } from "app/modules/shared/services/message/toast.service";
import { KlLoadingService } from "app/modules/shared/services/kl-loading.service";
import { BaseForm } from "app/data/shared/models/base-form.interface";
import { UtilService } from "app/modules/shared/services/util.service";
import {
  ExplorerService,
  ModalConfig,
} from "app/modules/shared/services/explorer.service";
import { TranslateService } from "app/modules/shared/services/translate/translate.service";
import { PrimengLocal } from "@app/modules/shared/constants/primeng-local";
import { DynamicComponent } from "@app/data/dashboard/interfaces/dynamic-component.interface";
import { CurrentAccountListComponent } from "@dashboard/modules/finance-management/current-account/components/current-account-list/current-account-list.component";
import { of, Subscription } from "rxjs";

@Component({
  selector: "kl-user-form",
  templateUrl: "./user-form.component.html",
  styleUrls: ["./user-form.component.scss"],
})
export class UserFormComponent
  implements OnInit, AfterViewInit, OnDestroy, BaseForm
{
  @ViewChild("focusElement", { static: true }) private focusElement: ElementRef;
  @ViewChild("branchGrid", { static: true })
  private branchGrid: wjGrid.FlexGrid;
  @ViewChild("userForm", { static: true }) private userForm: any;
  @ViewChild("branchModal", { static: true }) private branchModal: any;
  @Input() tabId: string;
  @Input() listTabId: string;
  @Input() modalId: string;
  @Input() isReadOnly: boolean;
  @Input() mode: string;
  @Input() entity: UserDto = new UserDto();
  locale =
    PrimengLocal[
      localStorage.getItem("currentLanguage")
        ? localStorage.getItem("currentLanguage").toUpperCase()
        : "TR"
    ];
  title = "";
  alertShow: boolean;
  alertType: string;
  alertMessage: string;
  errorShow = false;
  isOpenFirstAccordion = true;
  isOpenSecondAccordion = false;
  showRoleGrid = false;
  roleCollectionView: wjCore.CollectionView;
  roles: any;
  roleListDataMap: any;
  dateFormatString: string;
  index: number;
  subscription: Subscription;
  subscriptionUser: Subscription;
  currentUser: UserDto;
  current_account_description = "";

  property = {
    property: {
      user: true,
    },
  };

  constructor(
    private toastService: ToastService,
    private apiService: ApiService,
    private translateService: TranslateService,
    private utilService: UtilService,
    private explorerService: ExplorerService,
    private klLoadingService: KlLoadingService
  ) {
    this.dateFormatString = UtilService.dateFormatString
      .toLowerCase()
      .replace("yy", "");
    this.subscription = explorerService.transferState$.subscribe((state) => {
      this.formChange(true);
      if (state.state === "CURRENT_ACCOUNT_CURRENT_ITEM") {
        this.current_account_description = state.payload.description;
        this.entity.curr_account_id = state.payload.id;
      }
    });
    this.subscriptionUser = explorerService.userStream$.subscribe((user) => {
      if (user) {
        this.currentUser = user;
      }
    });
  }

  ngOnInit() {
    this.getOthers();
    switch (this.mode) {
      case "add":
        this.entity.localization = "tr_TR";
        this.entity.roles = [];
        this.title =
          this.translateService.instant("new") +
          " " +
          this.translateService.instant("user");
        break;
      case "view":
      case "edit":
        this.entity.password_expired = new Date(this.entity.password_expired);
        this.title = this.translateService.instant("user") + " - ";
        break;
    }
    this.roleCollectionView = new wjCore.CollectionView(this.entity.roles);
    this.roleCollectionView.trackChanges = true;
  }

  ngAfterViewInit() {
    this.focusElement.nativeElement.focus();
  }

  openRoleAccordion(event) {
    this.isOpenSecondAccordion = event;
    if (!this.showRoleGrid) {
      this.showRoleGrid = true;
    }
  }

  formChange(event) {
    if (this.tabId) {
      this.explorerService.changeFormStatus({
        tabId: this.tabId,
        changeForm: event,
      });
    }
  }

  getOthers() {
    this.klLoadingService.show("loading");
    this.apiService.getAllData("role").subscribe(
      (response) => {
        this.roles = response ? response : [];
        this.roleListDataMap = new wjGrid.DataMap(
          this.roles,
          "id",
          "description"
        );
        if (this.mode === "add") {
          this.entity.roles.push(this.roleSourceDto());
        }
        if (this.entity.curr_account_id) {
          this.apiService
            .getDataById("current-account", this.entity.curr_account_id)
            .subscribe(
              (responseCurrentAccount) => {
                if (responseCurrentAccount === undefined) {
                  this.handleError("error_data");
                } else {
                  this.klLoadingService.hide();
                  this.current_account_description =
                    responseCurrentAccount.description;
                }
              },
              (errorCurrentAccount) => this.handleError(errorCurrentAccount)
            );
        } else {
          this.klLoadingService.hide();
        }
      },
      (error) => this.handleError(error)
    );
  }

  clearCurrentAccount() {
    delete this.entity.curr_account_id;
    this.current_account_description = "";
  }

  setModal() {
    const modalConfig = <ModalConfig>{
      title: "current_accounts",
      stateSelector: "CURRENT_ACCOUNT",
      childTemplate: <DynamicComponent>{
        mode: "DIALOG",
        dblSelect: true,
        template: CurrentAccountListComponent,
      },
    };
    this.explorerService.openModal(modalConfig);
  }

  roleSourceDto() {
    const dto = new Array({
      role: this.roles[0],
      rec_status: "NEW",
    });
    return dto[0];
  }

  addNewRoleRow(flexGrid?: any) {
    if (this.roleCollectionView.sourceCollection.length < 1) {
      this.formChange(true);
      this.entity.roles.push(this.roleSourceDto());
      this.roleCollectionView.refresh();
      if (flexGrid) {
        const lineRow = this.roleCollectionView.sourceCollection.length;
        const selectedCellRange = flexGrid.selection;
        selectedCellRange.row = lineRow - 1;
        selectedCellRange.col = 1;
        selectedCellRange.row2 = selectedCellRange.row;
        selectedCellRange.col2 = 1;
        flexGrid.select(selectedCellRange, true);
      }
    }
  }

  clearForm() {
    this.focusElement.nativeElement.focus();
    Object.keys(this.entity).forEach((o) => delete this.entity[o]);
    this.entity.localization = "tr_TR";
    this.entity.roles = [{ role: { id: null } }];
    this.roleCollectionView = new wjCore.CollectionView(this.entity.roles);
  }

  changeRoleColumn(event) {
    const col = event.flexGrid.columns[event.col];
    const dataItem = event.flexGrid.rows[event.row].dataItem;
    this.roleCollectionView.beginUpdate();
    this.roleCollectionView.editItem(dataItem);
    if (dataItem.id) {
      if (dataItem.hasOwnProperty("rec_status")) {
        dataItem.rec_status = "EDIT";
      } else {
        Object.assign(dataItem, { rec_status: "EDIT" });
      }
    }
    if (col.binding === "role.id") {
      let notFoundRole = true;
      this.roles.forEach((role) => {
        if (dataItem.role.id === role.id) {
          notFoundRole = false;
        }
      });
      if (notFoundRole) {
        dataItem.role = UtilService.deepCopy(this.roles[0]);
      }
    }
    this.roleCollectionView.commitEdit();
    this.roleCollectionView.endUpdate();
  }

  commitSave(action: any) {
    if (this.userForm.valid) {
      this.klLoadingService.show("saving");
      for (
        let i = 0;
        i < this.roleCollectionView.sourceCollection.length;
        i++
      ) {
        if (!this.roleCollectionView.sourceCollection[i].role.id) {
          this.roleCollectionView.remove(
            this.roleCollectionView.sourceCollection[i]
          );
          i = i - 1;
        }
      }
      this.entity.roles = this.roleCollectionView.sourceCollection;
      if (this.roleCollectionView.itemsRemoved.length > 0) {
        for (let i = 0; i < this.roleCollectionView.itemsRemoved.length; i++) {
          if (this.roleCollectionView.itemsRemoved[i].id) {
            if (this.roleCollectionView.itemsRemoved[i].rec_status) {
              this.roleCollectionView.itemsRemoved[i].rec_status = "DELETE";
            } else {
              Object.assign(this.roleCollectionView.itemsRemoved[i], {
                rec_status: "DELETE",
              });
            }
            this.entity.roles.push(this.roleCollectionView.itemsRemoved[i]);
          }
        }
      }
      if (this.roleCollectionView.sourceCollection.length > 0) {
        switch (action) {
          case "SAVE":
            switch (this.mode) {
              case "add":
                this.apiService.addData("user", this.entity).subscribe(
                  (response) => this.handleResponse(response),
                  (error) => this.handleError(error)
                );
                break;
              case "edit":
                this.apiService.updateData("user", this.entity).subscribe(
                  (response) => this.handleResponse(response),
                  (error) => this.handleError(error)
                );
                break;
            }
            break;
          case "SAVE_NEW":
            this.apiService.addData("user", this.entity).subscribe(
              (response) => this.handleNew(response),
              (error) => this.handleError(error)
            );
            break;
        }
      } else {
        this.handleError("user_role_required");
      }
    } else {
      this.handleError("required_fields_must_be_entered");
    }
  }

  handleResponse(response) {
    this.klLoadingService.hide();
    this.toastService.toastSuccess();
    if (this.currentUser) {
      if (this.currentUser.id === response.id) {
        this.apiService
          .getAllData("user/my")
          .subscribe((responseUser) =>
            this.explorerService.setUserProfile(responseUser)
          );
      }
    }
    if (this.tabId) {
      this.formChange(false);
      this.explorerService.closeTab(this.tabId);
    } else if (this.modalId) {
      this.explorerService.closeModal(this);
    }
    if (this.listTabId) {
      this.explorerService.setRefreshEndProsseses(this.listTabId);
    }
  }

  handleNew(response) {
    this.alertShow = false;
    this.errorShow = false;
    this.formChange(false);
    this.toastService.toastSuccess();
    this.clearForm();
    this.klLoadingService.hide();
  }

  handleError(error, commitError = false) {
    if (commitError) {
      if (this.roleCollectionView.sourceCollection) {
        if (this.roleCollectionView.sourceCollection.length === 0) {
          this.addNewRoleRow();
        }
      }
      if (this.entity.roles) {
        if (this.entity.roles.length > 0) {
          for (let i = 0; i < this.entity.roles.length; i++) {
            if (this.entity.roles[i].rec_status) {
              // rec_status property'i varsa
              if (this.entity.roles[i].rec_status === "DELETE") {
                // mükerrer obje oluşmasın diye statusu DELETE olan kayıtlar siliniyor
                this.entity.roles.splice(i, 1);
                i = i - 1;
              }
            }
          }
        }
      }
    }
    this.alertShow = true;
    this.errorShow = false;
    this.alertType = "error";
    this.alertMessage = this.utilService.alertErrorMessage(error);
    this.klLoadingService.hide();
    return of(null);
  }

  unlockEntity() {
    this.apiService.unlockData("user", this.entity.id).subscribe();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.subscriptionUser.unsubscribe();
    if (this.mode === "edit") {
      this.unlockEntity();
    }
  }
}
